<div class="organisationData__container">
  @if (userData.label) {
    <div class="organisationData__labeltext">
      {{userData.label}}
    </div>
  }
  @if (userData.data) {
    <div class="organisationData__valueText">
      {{userData.data}}
    </div>
  }
</div>
